function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/** 参考自 antd-mobile/toast/method, 其不满足业务场景里的一些动效、多实例效果、同示例可更改文案内容等需求, 所以有些修改 */

import React, { useEffect, useState, useCallback, useImperativeHandle, forwardRef, useRef } from 'react';
import ReactDOM from 'react-dom';
import classnames from 'classnames';
import { resolveContainer } from 'antd-mobile/es/utils/get-container';
import { InternalToast } from 'antd-mobile/es/components/toast/toast';
import 'antd-mobile/es/components/toast/toast.css';
import { mergeProps } from 'antd-mobile/es/utils/with-default-props';
import { mergeOptions, getIcon } from "./util";
const instances = [];
const defaultProps = {
  duration: 3000,
  position: 'top',
  maskClickable: true
};
const TempToast = /*#__PURE__*/forwardRef((firstProps, ref) => {
  const [visible, setVisible] = useState(false);
  const timer = useRef();
  const [props, updateNewProps] = useState(firstProps);
  useEffect(() => {
    setTimeout(() => setVisible(true));
    if (props.duration === 0) {
      return;
    }
    timer.current = window.setTimeout(close, props.duration);
    return () => {
      window.clearTimeout(timer.current);
      props.afterClose?.();
    };
  }, []);
  const close = useCallback(() => {
    setVisible(false);
    props.mode === 'white' ? setTimeout(props.destroy, 300) : props.destroy();
  }, []);
  useImperativeHandle(ref, () => ({
    close,
    update(opt) {
      updateNewProps({
        ...firstProps,
        icon: getIcon(opt) || firstProps.icon,
        content: opt.content
      });
    }
  }));
  return /*#__PURE__*/React.createElement(InternalToast, _extends({}, props, {
    visible: true,
    maskClassName: classnames(props.maskClassName, {
      visible
    })
  }));
});
TempToast.displayName = 'TempToast';
export function show(p) {
  const props = mergeProps(defaultProps, mergeOptions(p));
  const {
    getContainer = () => document.body
  } = props;
  const container = document.createElement('div');
  const bodyContainer = resolveContainer(getContainer);
  bodyContainer.appendChild(container);
  const destroy = () => {
    const unmountResult = ReactDOM.unmountComponentAtNode(container);
    if (unmountResult && container.parentNode) {
      container.parentNode.removeChild(container);
    }
  };
  clear();
  let instanceRef;
  ReactDOM.render( /*#__PURE__*/React.createElement(TempToast, _extends({}, props, {
    ref: r => instanceRef = r,
    getContainer: () => container,
    destroy: destroy
  })), container);
  const instance = {
    close: () => instanceRef?.close(),
    update: opt => instanceRef?.update(opt)
  };
  instances.push(instance);
  return instance;
}
export function clear() {
  while (instances.length) {
    instances.pop()?.close();
  }
}
export function config(val) {
  if (val.duration !== undefined) {
    defaultProps.duration = val.duration;
  }
  if (val.position !== undefined) {
    defaultProps.position = val.position;
  }
  if (val.maskClickable !== undefined) {
    defaultProps.maskClickable = val.maskClickable;
  }
}